var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6886 1.01019V14.8202C26.6286 15.0502 26.2586 15.5302 26.0086 15.5302H24.1186V5.07018C24.1186 4.20018 23.1386 2.88018 22.2286 2.88018H4.88861L4.80859 2.80016V1.0902C4.80859 0.660203 5.40859 0.200186 5.83859 0.260186C12.5586 0.300186 19.2986 0.200174 26.0086 0.310174C26.3486 0.420174 26.5686 0.690195 26.6886 1.0202V1.01019Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7491 9.53027V18.6802C22.7491 19.1102 22.1491 19.5703 21.7191 19.5103H1.79913C1.43913 19.5303 0.869141 19.0802 0.869141 18.7302V9.53027H22.7491ZM3.98914 15.4402C3.21914 15.6102 3.22914 16.5902 3.98914 16.7902H11.1491C11.9691 16.7302 12.0092 15.5502 11.1992 15.4402H4.00916H3.98914Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7491 8.16983H0.869141V4.96981C0.869141 4.76981 1.22916 4.33982 1.44916 4.28982C8.31916 4.18982 15.2192 4.23986 22.0992 4.26986C22.3392 4.36986 22.5292 4.48983 22.6392 4.73983C22.6592 4.77983 22.7491 5.05986 22.7491 5.07986V8.17984V8.16983Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.e966a2b51d1362172aeeff1f8a27f626.svg";
export { ForwardRef as ReactComponent };